import React from "react";

export default function AnnualPlanBanner() {
  return (
    <div className="annual-plan-banner">
      <img
        src={`${process.env.PUBLIC_URL}/coroa_contorno_alta.png`}
        alt=""
        className="annual-plan-banner-icon"
      />
      <p>
        Adquira as matérias avulsas abaixo. Ou assine o{" "}
        <strong>Plano Anual</strong> e tenha acesso ilimitado a todos os
        Cadernos, atualizações e lançamentos durante 12 meses.
      </p>
    </div>
  );
}
